'use strict';

var GridExpandButtonDirective = function GridExpandButtonDirective() {
  return {
    scope: {
      gridId: '@',
      screenState: '='
    },
    restrict: 'E',
    require: '^^rmGridToolbar',
    template: require('../templates/grid-expand-button.html'),
    controller: 'GridExpandButtonController'
  };
};
GridExpandButtonDirective.$inject = [];
module.exports = GridExpandButtonDirective;